function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.80472 6.75684V8.16137C3.80472 8.39779 4.00197 8.57855 4.25989 8.57855C5.03371 8.57855 5.67097 9.16263 5.67097 9.87186C5.67097 10.5811 5.03371 11.1652 4.25989 11.1652C3.48608 11.1652 2.84882 10.5811 2.84882 9.87186C2.84882 9.63544 2.65157 9.45468 2.39365 9.45468C2.13573 9.45468 1.93848 9.63546 1.93848 9.87186C1.93848 11.04 2.9854 11.9995 4.25992 11.9995C5.53444 11.9995 6.58137 11.04 6.58137 9.87186C6.58137 8.84279 5.7772 7.98059 4.71512 7.7859V6.75684H3.80472V6.75684Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00487 6.82678C6.17177 6.82678 6.32348 6.74334 6.39937 6.61818L8.46287 3.225C8.56907 3.04422 8.52356 2.83561 8.35666 2.69656L6.29316 1.09734C6.21731 1.02782 6.11107 1 6.00487 1H2.51513C2.40893 1 2.30272 1.04171 2.22684 1.09734L0.16334 2.69659C-0.00356262 2.82174 -0.0490709 3.04424 0.0571344 3.22503L2.12063 6.61821C2.19649 6.75726 2.34823 6.82681 2.51513 6.82681H3.80482H4.71518H6.00487V6.82678Z"
});

function SvgHook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHook);
export default __webpack_public_path__ + "static/media/hook.53e3185e.svg";
export { ForwardRef as ReactComponent };